export const NEW_CREATED_VM_ID_LIST = "NEW_CREATED_VM_ID_LIST";
